import { stringField, optionField, dateField, booleanField } from 'common/utils/form/fieldTypes';

export default {
  photo_id: stringField(),
  prefix_id: optionField(),
  code: stringField({ required: true }),
  name: stringField({ required: true }),
  type_id: optionField(),
  active: booleanField(),
  owner_id: optionField(),
  flag_country_id: optionField(),
  imo_no: stringField(),
  build_date: dateField()
};
